import { mutationOptions, type QueryClient } from '@tanstack/react-query';

import { createHeySynclyPromptLibrary } from './create-prompt-library';
import { deleteHeySynclyPromptLibrary } from './delete-prompt-library';
import { heySynclyPromptLibraryQueryKeys } from './hey-syncly-prompt-library.queries';
import { updateHeySynclyPromptLibrary } from './update-prompt-library';

const invalidatePromptLibraryList = (
  queryClient: QueryClient,
  workspaceId: string,
) =>
  queryClient.invalidateQueries({
    queryKey: heySynclyPromptLibraryQueryKeys.list(workspaceId),
  });

export const createHeySynclyPromptLibraryMutationOptions = (
  queryClient: QueryClient,
) =>
  mutationOptions({
    mutationFn: createHeySynclyPromptLibrary,
    onSuccess: (_data, variables) =>
      invalidatePromptLibraryList(queryClient, variables.workspace_id),
  });

export const updateHeySynclyPromptLibraryMutationOptions = (
  queryClient: QueryClient,
) =>
  mutationOptions({
    mutationFn: updateHeySynclyPromptLibrary,
    onSuccess: (_data, variables) =>
      invalidatePromptLibraryList(queryClient, variables.workspace_id),
  });

export const deleteHeySynclyPromptLibraryMutationOptions = (
  queryClient: QueryClient,
) =>
  mutationOptions({
    mutationFn: deleteHeySynclyPromptLibrary,
    onSuccess: (_data, variables) =>
      invalidatePromptLibraryList(queryClient, variables.workspace_id),
  });
